import norlysLogo from '~shared-assets/images/norlys-logo.png';
import nordeaLogo from '~shared-assets/images/nordea-logo.png';
import jyskebankLogo from '~shared-assets/images/jyskebank-logo.png';
import edcLogo from '~shared-assets/images/edc-logo.png';

import { Image } from 'antd';
import styled from 'styled-components';

import { Heading } from '~src/components/Typography';
import { useDisplayContext } from '~src/context/DisplayContext';

type PartnerLogosProps = {
  variant?: 'default' | 'offerIdentity';
};

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
});

const PartnerLogosWrapper = styled.div<PartnerLogosProps>(({ variant }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: variant === 'offerIdentity' ? 'clamp(10px, 1.6vw, 18px)' : '16px',
  marginBottom: variant === 'offerIdentity' ? '12px' : '16px',
  width: '100%',
  flexWrap: 'wrap',
}));

const PARTNER_LOGO_IMAGES = {
  norlys: { url: norlysLogo, width: '15%', offerWidth: '21%' },
  nordea: { url: nordeaLogo, width: '15%', offerWidth: '21%' },
  jyskebank: { url: jyskebankLogo, width: '15%', offerWidth: '21%' },
  edc: { url: edcLogo, width: '8%', offerWidth: '14%' },
};

export const PartnerLogos = ({ variant = 'default' }: PartnerLogosProps) => {
  const logoUrls = usePartnerLogos();

  const isSingleLogo = logoUrls?.length === 1;

  return (
    <Wrapper>
      <PartnerLogosWrapper variant={variant}>
        {logoUrls.map(({ url, width, offerWidth }) => {
          const imageWidth =
            variant === 'offerIdentity' ? (isSingleLogo ? '34%' : offerWidth) : isSingleLogo ? '25%' : width;

          return <Image key={url} width={imageWidth} preview={false} src={url} />;
        })}
      </PartnerLogosWrapper>

      <Heading level={4}>{variant === 'offerIdentity' ? 'Vores partnere' : 'Vi samarbejder med de bedste'}</Heading>
    </Wrapper>
  );
};

export const usePartnerLogos = () => {
  const { leadOrigin } = useDisplayContext();

  if (leadOrigin === 'jyskebank') {
    return [PARTNER_LOGO_IMAGES.jyskebank];
  }

  if (leadOrigin === 'nordea') {
    return [PARTNER_LOGO_IMAGES.nordea];
  }

  return Object.values(PARTNER_LOGO_IMAGES);
};
